export const companySeekerRoleOptions = [
  {
    id: "01",
    companyType: "company_seeker",
    value: "Corporation",
    databaseName: "corporations",
    subValue: [
      { id: "02", value: "Small", databaseName: "small" },
      { id: "03", value: "Medium", databaseName: "medium" },
      { id: "04", value: "Large", databaseName: "large" },
    ],
  },
  {
    id: "05",
    companyType: "company_seeker",
    value: "Affiliate",
    databaseName: "affiliates",
    subValue: [
      {
        id: "06",
        value: "Black Student Union",
        databaseName: "black_student_unions",
      },
      {
        id: "07",
        value: "Civic Organization",
        databaseName: "civic_organizations",
      },
      { id: "09", value: "HBCU", databaseName: "hbcus" },
      {
        id: "10",
        value: "Black College or University",
        databaseName: "black_colleges_and_universities",
      },
      {
        id: "11",
        value: "Professional Organization",
        databaseName: "professional_organizations",
      },
      {
        id: "12",
        value: "Sorority or Fraternity",
        databaseName: "sororities_and_fraternities",
      },
      {
        id: "13",
        value: "Trade Association",
        databaseName: "trade_associations",
      },
    ],
  },
  {
    id: "14",
    companyType: "company_seeker",
    value: "Financial Services",
    databaseName: "financial_organizations",
    subValue: [
      { id: "15", value: "Banking", databaseName: "banking" },
      {
        id: "16",
        value: "Angel investors",
        databaseName: "angel_investors",
      },
      { id: "17", value: "Debt Financing", databaseName: "debt_financing" },
      {
        id: "18",
        value: "Working Capital Financing",
        databaseName: "working_capital_financing",
      },
      {
        id: "19",
        value: "Merger or Acquisition",
        databaseName: "mergers_and_acquisitions",
      },
      { id: "20", value: "Private Equity", databaseName: "private_acquity" },
      {
        id: "21",
        value: "Wealth Management",
        databaseName: "wealth_management",
      },
      { id: "22", value: "Venture Capital", databaseName: "venture_capital" },
    ],
  },
  {
    id: "23",
    companyType: "company_seeker",
    value: "International Companies",
    databaseName: "international_companies",
    subValue: [
      { id: "24", value: "Business", databaseName: "businesses" },
      { id: "25", value: "Executive", databaseName: "executives" },
      { id: "26", value: "Professional", databaseName: "professionals" },
      { id: "27", value: "Student", databaseName: "students" },
    ],
  },

  {
    id: "34",
    companyType: "company_seeker",
    value: "Platinum Companies",
    databaseName: "corporate",
    subValue: [
      {
        id: "35",
        value: "Diversity & Inclusion",
        databaseName: "diversity_and_inclusion",
      },
      { id: "36", value: "Officer", databaseName: "officers" },
      { id: "37", value: "HR Practitioner", databaseName: "hr_practitioners" },
      { id: "38", value: "Hiring Manager", databaseName: "hiring_managers" },
      {
        id: "39",
        value: "Supplier Diversity Manager",
        databaseName: "supplier_diversity_managers",
      },
      { id: "41", value: "Manager", databaseName: "managers" },
      { id: "42", value: "VP, Engineering", databaseName: "vp_engineering" },
      {
        id: "43",
        value: "VP, Product Marketing",
        databaseName: "vp_product_marketing",
      },
    ],
  },
  {
    id: "54",
    companyType: "company_seeker",
    value: "Gold Companies",
    databaseName: "gold_companies",
    subValue: [
      { id: "55", value: "Small", databaseName: "small" },
      { id: "56", value: "Medium", databaseName: "medium" },
      { id: "57", value: "Large", databaseName: "large" },
    ],
  },
]
